/************
 * Model Class
 * File Name ...: request-summary.components.ts
 * Generated By : ianday on 11/15/23
 * Date ........: 11/15/23
 /************/
import {ValidationResult} from './validation-result';

export interface RequestSummary {
    dateCreated: string | null;
    requestType: string | null;
    statusDesc: string | null;
    amountRequested: string | null;
    unitOfMeasure: string | null;
    totalAmountProvided: string | null;
    source: string | null;
    agencyName: string | null;
    statusColor: string | null;
    currentNeed: string | null;
    dateCompleted: Date | null;
    clericalOpen: number | null;
    
}

export class RequestSummary {

    constructor() {
        this.dateCreated = '';
        this.requestType = '';
        this.statusDesc = '';
        this.amountRequested = '';
        this.unitOfMeasure = '';
        this.source = '';
        this.agencyName = '';
        this.statusColor = '';
        this.currentNeed = '';
    }

}
